var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ProgramPageHeader',{attrs:{"name":_vm.name,"pageId":_vm.pageId}}),_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }